import loadable from '@wix/yoshi-flow-editor/loadable';

export const DateFnsLocales = loadable.lib(() => import('date-fns/locale'));
